import { useState } from "react";
import { useTranslation } from "react-i18next";

import { htmlToText } from "@/domains/certifications/utils";
import {
  CASE_KINDS,
  COLLAPSE_AFTER_CHARACTERS,
} from "@/features/community/moderation/constants";
import {
  getCaseContent,
  getCaseKind,
} from "@/features/community/moderation/utils";
import { CaseBodyProps } from "@/features/community/moderation/types";

import "../styles.css";

const CaseBody = ({ moderationCase }: CaseBodyProps) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const kind = getCaseKind(moderationCase);
  const content = getCaseContent(moderationCase);
  const { discussion, replyTo } = moderationCase;

  const text = content ? htmlToText(content.body) : "";
  const isLong = text.length > COLLAPSE_AFTER_CHARACTERS;

  return (
    <div className="moderation-card-body flex flex-col gap-200">
      {kind !== CASE_KINDS.POST && discussion && (
        <blockquote className="moderation-quote flex flex-col gap-50">
          <span className="body-xs-regular">
            {t("moderation.case.onPost", { title: discussion.title })}
          </span>

          <p className="moderation-quote-text body-s-regular">
            {htmlToText(discussion.body)}
          </p>
        </blockquote>
      )}

      {kind === CASE_KINDS.REPLY && replyTo && (
        <blockquote className="moderation-quote flex flex-col gap-50">
          <span className="body-xs-regular">
            {t("moderation.case.commented", {
              name: replyTo.author?.fullName.trim() || replyTo.author?.email,
            })}
          </span>

          <p className="moderation-quote-text body-s-regular">
            {htmlToText(replyTo.body)}
          </p>
        </blockquote>
      )}

      {kind === CASE_KINDS.POST && discussion && (
        <h3 className="moderation-title body-m-medium">{discussion.title}</h3>
      )}

      {content ? (
        <p
          className={`moderation-text body-m-regular ${
            isLong && !isExpanded ? "moderation-text-collapsed" : ""
          }`}
        >
          {text}
        </p>
      ) : (
        <p className="moderation-muted body-s-regular">
          {t("moderation.case.contentGone")}
        </p>
      )}

      {isLong && (
        <div>
          <button
            type="button"
            className="moderation-link-button body-s-medium"
            aria-expanded={isExpanded}
            onClick={() => setIsExpanded((value) => !value)}
          >
            {isExpanded
              ? t("moderation.case.showLess")
              : t("moderation.case.showMore")}
          </button>
        </div>
      )}
    </div>
  );
};

export default CaseBody;
